

import PricingButton from "@/components/main/pricing/PricingButton";
export default {
  name: "BoxWithIcon",
  components: {PricingButton},

  props:['item', 'buttons']
}
